import { Component, OnInit } from '@angular/core';
import { BaseControlComponent } from "../../../../../../form-controls/components/base-control/base-control.component";
import { ContextInteractionService } from "../../../../../../form-controls/services/context-interaction.service";
import { Option } from "../../../../../../common/models/flow.dto";

@Component({
    selector: 'app-casing-plan-schematic-display-config',
    templateUrl: './casing-plan-schematic-display-config.component.html',
    styleUrls: ['./casing-plan-schematic-display-config.component.scss'],
    standalone: false
})
export class CasingPlanSchematicDisplayConfigComponent extends BaseControlComponent implements OnInit {

    static componentName = "CasingPlanSchematicDisplayConfigComponent";

    constructor(contextService: ContextInteractionService) {
        super(contextService);
    }

    displayOptions: Option[] = [
        { id: "all", text: "Summary and Detail" } as Option,
        { id: "summary", text: "Summary Only" } as Option,
        { id: "detail", text: "Detail Only" } as Option
    ]

    ngOnInit() {
        if (this.componentData == null) this.componentData = {};
        if (this.componentData.config == null) this.componentData.config = {};
        if (this.componentData.config.display == null) this.componentData.config.display = "all";      
    }

    onCheckedChanged(opt: string): void {
        this.componentData.config.display = opt; 
    }
}
